import { gsap } from 'gsap';
import { H } from '../highway';
import { mq } from '../util/matchMedia';

export const WipeDown = (from, to, done) => {
  const mask = document.querySelector('.js-mask');
  const logo = document.querySelector('.js-navigation-logo');
  const nav = document.querySelector('.js-navigation');
  let logoVisibility = H.properties.slug === 'home' ? 0 : 1;

  const tl = gsap.timeline({ onComplete: done });

  tl
    .set(to, { autoAlpha: 0 })
    .set(mask, { y: '100%', autoAlpha: 1 }, 0)

    .to(mask, {
      y: 0,
      duration: 1.117,
      ease: 'kota.easeInOut.2',
      onComplete: () => from.remove(),
    }, 0)

    .to(from, {
      y: '-15%',
      duration: 1.083,
      ease: 'kota.easeInOut.3',
    }, 0.02)

    .to(mask, { opacity: 0, duration: 0.1 })

    .to(to, { autoAlpha: 1, duration: 0.1 }, '<')

    .to(nav, {
      duration: 0.467,
      autoAlpha: 1,
    }, 0.03)

  if (mq.isDesktop) {
    tl.to(logo, {
      autoAlpha: logoVisibility,
      duration: 0.467,
      ease: 'kota.easeIn.1',
    }, 0.03);
  }

  return tl;
}